import os from 'node:os'

/**
 * Get your local network ip address
 */
export function getLocalIP() {
  const networkInterfaces = os.networkInterfaces()

  for (const interfaceName in networkInterfaces) {
    if (
      Object.prototype.hasOwnProperty.call(networkInterfaces, interfaceName)
    ) {
      const interfaces = networkInterfaces[interfaceName]
      if (interfaces) {
        for (const networkInterface of interfaces) {
          if (
            networkInterface.family === 'IPv4' &&
            !networkInterface.internal
          ) {
            return networkInterface.address
          }
        }
      }
    }
  }
  return null // Return null if no valid IP is found
}
